<template>
	<div>
		<commonHeader />
		<div v-if="nowWidth > 784">
			<div class="contact_1">
				<v-img src="/image/contact_1.png" class="px-pc">
					<div class="about_1_text" style="text-shadow: 3px 3px 9px black;">
						Contact Us
					</div>
					<v-layout>
						<v-layout class="tab-css-2" wrap>
							<v-flex xs3 v-for="(tab, i) in $store.state.tabList" :key="i" class="pr-12">
								<v-flex xs12>
									<v-divider dark class="main-hr-1 mb-4"></v-divider>
								</v-flex>
								<div>
									<div class="number mr-2">0{{ i + 1 }}</div>
									<div class="Title" :style="i < 4 ? 'padding-right: 40px;' : 'padding-right: 0px;'" @click="titleGoto(tab.link)">
										{{ tab.title }}
									</div>
								</div>
							</v-flex>
						</v-layout>
					</v-layout>
				</v-img>
			</div>
			<v-layout class="px-pc contact-layout" wrap>
				<v-flex xs6>
					<div class="img">
						<v-img height="300" contain position="right" src="/image/contact_2.png"></v-img>
					</div>
				</v-flex>
				<v-flex xs6>
					<div>
						<v-layout class="contact-text" align-center>
							<div class="icon">
								<v-img width="36" height="36" src="/image/contact_icon_1.png"></v-img>
							</div>
							<div class="t">
								02 3484 7081
							</div>
						</v-layout>
						<v-layout class="contact-text" align-center>
							<div class="icon">
								<v-img width="36" height="36" src="/image/contact_icon_2.png"></v-img>
							</div>
							<div class="t">
								02 3484 7077
							</div>
						</v-layout>
						<v-layout class="contact-text" align-center>
							<div class="icon">
								<v-img width="36" height="36" src="/image/contact_icon_3.png"></v-img>
							</div>
							<div class="t">
								admin@semainv.com
							</div>
						</v-layout>
						<v-layout class="contact-text" align-center>
							<div class="icon">
								<v-img width="36" height="36" src="/image/contact_icon_4.png"></v-img>
							</div>
							<div class="t">
								서울시 강남구 영동대로 416, 3층<br />
								(대치동, KT&G타워)
							</div>
						</v-layout>
					</div>
				</v-flex>
			</v-layout>
			<v-layout wrap class="px-pc team_last">
				<v-flex xs12>
					<iframe
						src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3165.0581711920386!2d127.06312741558722!3d37.50654613531868!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca43f66e55c4d%3A0xcfe1999e69489469!2z7ISc7Jq47Yq567OE7IucIOqwleuCqOq1rCDsmIHrj5nrjIDroZwgNDE2!5e0!3m2!1sko!2skr!4v1660026552198!5m2!1sko!2skr"
						width="100%"
						height="630"
						style="border:0;"
						allowfullscreen=""
						loading="lazy"
						referrerpolicy="no-referrer-when-downgrade"
					></iframe>
				</v-flex>
			</v-layout>
		</div>
		<div v-else>
			<div class="m_contact_1">
				<v-img width="100%" src="/image/m_contact_1.png" class="pl-6">
					<div class="m_about_1_text" style="text-shadow: 3px 3px 9px black;">
						Contact Us
					</div>
				</v-img>
			</div>
			<v-layout class="m_contact_layout">
				<hr class="m_divider_4" />
				<div class="t">
					서울시 강남구 영동대로 416, 3층<br />
					(대치동, KT&G타워)
				</div>
			</v-layout>
			<v-layout class="m_contact_icon mb-4" align-center>
				<div class="icon">
					<v-img contain width="24" height="24" src="/image/contact_icon_1.png"></v-img>
				</div>
				<div class="t">02 3484 7081</div>
			</v-layout>
			<v-layout class="m_contact_icon mb-4" align-center>
				<div class="icon">
					<v-img contain width="24" height="24" src="/image/contact_icon_2.png"></v-img>
				</div>
				<div class="t">02 3484 7077</div>
			</v-layout>
			<v-layout class="m_contact_icon mb-10" align-center>
				<div class="icon">
					<v-img contain width="24" height="24" src="/image/contact_icon_3.png"></v-img>
				</div>
				<div class="t">admin@semainv.com</div>
			</v-layout>
			<v-layout wrap>
				<v-flex xs12>
					<iframe
						src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3165.0581711920386!2d127.06312741558722!3d37.50654613531868!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca43f66e55c4d%3A0xcfe1999e69489469!2z7ISc7Jq47Yq567OE7IucIOqwleuCqOq1rCDsmIHrj5nrjIDroZwgNDE2!5e0!3m2!1sko!2skr!4v1660026552198!5m2!1sko!2skr"
						width="100%"
						height="630"
						style="border:0;"
						allowfullscreen=""
						loading="lazy"
						referrerpolicy="no-referrer-when-downgrade"
					></iframe>
				</v-flex>
			</v-layout>
		</div>
		<commonFooter />
	</div>
</template>
<script>
import { commonHeader, commonFooter } from '@/components/index'
export default {
	components: {
		commonHeader,
		commonFooter,
	},
	data() {
		return {
			screenWidth: window.innerWidth,
			contact: {
				name: '',
				email: '',
				subject: '',
				message: '',
			},
			aboutCards: [
				{
					title: 'First',
					content: `Considering business<br /> directions as a partner`,
				},
				{
					title: 'Second',
					content: `Giving support for funding<br /> and follow-up investments`,
				},
				{
					title: 'Third',
					content: `Passing on knowledge and<br /> experience for successful<br /> business foundations`,
				},
				{
					title: 'Fourth',
					content: `Offering human networks<br /> for business value increases`,
				},
			],
		}
	},
	computed: {
		nowWidth() {
			window.addEventListener('resize', () => {
				this.screenWidth = window.innerWidth
			})
			return this.screenWidth
		},
	},
	methods: {
		titleGoto(link) {
			this.$router.push({ name: link })
		},
	},
}
</script>
<style lang="scss">
.contact-layout {
	margin: 90px 0;
	padding: 0 20%;
}
.gmap_canvas {
	overflow: hidden;
	background: none !important;
	height: 500px;
	width: 600px;
}
.mapouter {
	position: relative;
	text-align: right;
	height: 500px;
	width: 600px;
}
.contact_title {
	margin-top: 24px;
	text-align: center;
	font-size: 30px;
	color: #2c2c2c;
	font-weight: 300;
	letter-spacing: -1px;
	line-height: 40px;
}
.contact_main_1 {
	margin-top: 64px;
	height: 315px;
	background-image: url('/image/contact_main_1.jpg');
	background-size: cover;
}
.contact-title-2 {
	font-family: 'Noto Serif KR', serif !important;
	font-size: 48px;
	color: #2c2c2c;
	font-weight: 400;
	letter-spacing: -3px;
	line-height: 60px;
}
.contact-title-1 {
	font-family: 'Noto Serif KR', serif !important;
	font-size: 36px;
	color: #000000;
	font-weight: 700;
	letter-spacing: -3px;
	line-height: 60px;
}
</style>
